import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            精选视频
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            大赛精选创作视频，感受优秀创作者的独特视角
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-foreground-900/10 group-hover:bg-foreground-900/20 transition-colors flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90">
                      <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-foreground-900/70 text-background-50 rounded">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1.5 line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{item.author}</span>
                    <span>{item.views} 次观看</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}